import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PublicHeaderComponent} from './components/header/public-header.component';

import 'hammerjs';
import 'mousetrap';

import {RouterModule} from '@angular/router';
import {WINDOW_PROVIDERS} from '../shared/service/windows.service';
import {PublicContentLayoutComponent} from './layout/content-layout/public-content-layout.component';
import {PublicFeatherIconsComponent} from './components/feather-icons/public-feather-icons.component';
import {PublicFooterComponent} from './components/footer/public-footer.component';
import {PublicFullscreenDirective} from './directives/publicfullscreen.directive';
import {PublicComparatorComponent, SafeHtmlPipe} from './comparator/public-comparator.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {OnboardingRoutingModule} from './onboarding/onboarding-routing.module';
import {RegisterComponent} from './onboarding/register/register.component';
import {RegistrationService} from './onboarding/services/registration.service';
import {PublicComparatorService} from './comparator/services/public.comparator.service';
import {ComparatorGasResultComponent} from './comparator/comparator-gas-result/comparator-gas-result.component';
import {ComparatorEnergyResultComponent} from './comparator/comparator-energy-result/comparator-energy-result.component';
import {GasComparatorTableComponent} from './comparator/gas-comparator-table/gas-comparator-table.component';
import {ElectricComparatorTableComponent} from './comparator/electric-comparator-table/electric-comparator-table.component';
import {OfferService} from './comparator/services/offer.service';
import {ModalDocumentsComponent} from './comparator/modal-documents/modal-documents.component';
import {CKEditorModule} from 'ngx-ckeditor';
import {ConsumptionPlaceElectricComponent} from './consumption-place-electric/consumption-place-electric.component';
import {ConsumptionPlaceGasComponent} from './consumption-place-gas/consumption-place-gas.component';
import {DragDropFileUploadDirective} from './directives/drag-drop-file-upload.directive';
import {SharedModule} from '../shared/shared.module';
import {ContractIndexComponent} from './contract-index/contract-index.component';
import {RegisterRoeidComponent} from './onboarding/register-roeid/register-roeid.component';

@NgModule({
  declarations: [
    PublicFullscreenDirective,
    PublicFeatherIconsComponent,
    PublicFooterComponent,
    PublicHeaderComponent,
    PublicContentLayoutComponent,
    PublicComparatorComponent,
    RegisterComponent,
    RegisterRoeidComponent,
    SafeHtmlPipe,
    ComparatorGasResultComponent,
    ComparatorEnergyResultComponent,
    GasComparatorTableComponent,
    ElectricComparatorTableComponent,
    ModalDocumentsComponent,
    ConsumptionPlaceElectricComponent,
    ConsumptionPlaceGasComponent,
    DragDropFileUploadDirective,
    ContractIndexComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgbModule,
    CKEditorModule,
    FormsModule,
    OnboardingRoutingModule,
    SharedModule
  ],
  providers: [WINDOW_PROVIDERS, RegistrationService, PublicComparatorService, OfferService],
  exports: [
    PublicFeatherIconsComponent,
    PublicFullscreenDirective,
    PublicContentLayoutComponent,
    RegisterComponent,
    PublicComparatorComponent,
    ComparatorEnergyResultComponent,
    ComparatorGasResultComponent,
    ConsumptionPlaceElectricComponent,
    ConsumptionPlaceGasComponent,
    DragDropFileUploadDirective,
    PublicFooterComponent,
    PublicHeaderComponent,
    ContractIndexComponent
  ]
})
export class PublicModule {
}
